/**
 * Created by maitray on 24/3/16.
 */

'use strict';

angular.module('adelementAdminApp')
    .factory('JhiAuthorities', function ($resource, DateUtils) {
        return $resource('api/jhiauthorities/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    });

